import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, inject, viewChild } from "@angular/core";
import { TinyColor } from "@ctrl/tinycolor";

@Component({
  selector: "app-point-color",
  templateUrl: "./point-color.component.html",
  styleUrls: ["./point-color.component.scss"],
  standalone: false,
})
export class PointColorComponent implements AfterViewInit {
  private renderer = inject(Renderer2);

  @Input()
  set color(value: string) {
    this._color = value;
    if (this.pointRef()) this.setColor(value);
  }

  get color() {
    return this._color;
  }

  readonly pointRef = viewChild<ElementRef<HTMLDivElement>>("point");

  private _color: string;

  ngAfterViewInit(): void {
    this.setColor(this.color);
  }

  setColor(c: string) {
    const color = new TinyColor(c);
    const pointRef = this.pointRef();
    this.renderer.setStyle(
      pointRef.nativeElement,
      "background-color",
      color.toRgbString()
    );
    this.renderer.setStyle(
      pointRef.nativeElement,
      "box-shadow",
      `0 0 0 4px ${color.setAlpha(0.5).toRgbString()}`
    );
  }
}
